import React from "react";

export const EMobility = [
  <>
    <h4 className="slideTitle">
      Creating a E-Mobility convenience ecosystem
      <br />
      <span>Home to business locations via on-the-go-learning</span>
    </h4>
    <div className="slideContainer slide_solidColour">
      <div className="">
        <h4 className="slideTitle">E-Mobility Infrastructure</h4>
        <p>
          An end-to-end solution set for a seamless experience to customers
          undergoing the electrification of their fleets. Our tailor-made
          solutions include:
        </p>
        <ul className="shell_bullets_list">
          <li>Renewable power generation</li>
          <li>
            Charging network: on the go, at destination, depot & hubs and at
            home
          </li>
          <li>
            Conventional & high-powered or fast charging with back-up Battery
            system
          </li>
          <li>Software & analytics</li>
          <li>E-Fluids & E-Greases</li>
        </ul>
      </div>
      {/* <div className="colRight col70">
        <img
          src="images/eMobility-ecosystem.png"
          width="100%"
          height="auto"
          alt=""
        />
      </div> */}
    </div>
  </>,
  <>
    <h4 className="slideTitle">Creating a E-Mobility convenience ecosystem</h4>
    <div className="slideContainer slide_solidColour">
      <img
        src="images/eMobility-ecosystem.png"
        width="100%"
        height="auto"
        alt=""
      />
    </div>
  </>,
  <>
    <h4 className="slideTitle">A complete offer for all customer segments</h4>
    <div className="slideContainer slide_solidColour">
      <img
        src="images/eMobility-segments.JPG"
        width="100%"
        height="auto"
        className="mx-auto"
      />
    </div>
  </>,

  <div className="slideContainer slide_solidColour noGutters">
    <div className="colLeft col50 backgroundImage">
      <img src="images/eMobility-ev-only.jpg" width="100%" height="auto" />
    </div>
    <div className="colRight col50 solidColourContainer stats">
      <h4 class="slideTitle">Shell Fulham, London, UK – EV only station</h4>
      <ul className="shell_bullets_list">
        <li>9 fast chargers</li>
        <li>Solar panels built into the roof canopies</li>
        <li>100% certified renewable electricity</li>
        <li>Coffee/shop via partners</li>
      </ul>
    </div>
  </div>,
  <>
    <h4 className="slideTitle">
      We take a holistic approach to hub development
    </h4>
    <div className="slideContainer slide_solidColour">
      <img src="images/eMobility-holistic.JPG" width="100%" height="auto" />
    </div>
  </>,
  <>
    {/* <h4 className="slideTitle">A complete offer for all customer segments</h4> */}
    <div className="slideContainer slide_solidColour">
      <img
        src="images/eMobility-partnerships.JPG"
        width="100%"
        height="auto"
        className="mx-auto"
      />
    </div>
  </>,
];
